import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, {useState} from 'react';
import Style from 'styles/components/comachicart/faq.module.scss';

const Accordion = ({ title, content }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className={classNames(Style.faq__title)} onClick={() => setOpen(!open)}>
        <div>{title}</div>
        <span className={classNames({ [Style.faq__title__icon]: true, [Style.reverse]: open })}>
          <FontAwesomeIcon icon={faChevronDown} />
        </span>
      </div>
      <div className={classNames({ [Style.faq__content]: true, [Style.open]: open })}>
        <div className={classNames({ [Style.faq__content__text]: true })}>{content}</div>
      </div>
    </>
  );
};

const FAQPresenter = ({ faq }) => {
  return (
    <section>
      <h2 className={classNames(Style.catch)}>
        <span>FAQ</span>
      </h2>
      <div className={classNames(Style.sub_catch)}>
        <span>{faq.title}</span>
      </div>
      <div className={classNames(Style.faq)}>
        {faq.rows.map(row => (
          <Accordion key={row.title} title={row.title} content={row.content} />
        ))}
      </div>
    </section>
  );
}
;

const topFAQ = {
  title: 'よくある質問',
  rows: [
    {
      title: '初めてで知識が無いのですが、問題なくショップ開設・運営は行えますか？',
      content: (
        <>
          はい、comachicartはプログラミングなどの専門的な知識を必要とせず、直観的に操作が行えるサービスとなっています。また、
          <a href='https://manual.comachicart.com/'>オンラインマニュアル</a>
          も用意しておりますので、そちらを必要に応じてご確認いただくこともできます。
        </>
      ),
    },
    {
      title: '利用可能な決済サービスはなんですか？',
      content: (
        <>
          comachicartでは、以下の決済サービスの設定が可能です。ご利用にあたり、各決済サービス提供会社へのお申し込みが必要となります。
          <br />
          ・代金引換
          <br />
          ・銀行振込
          <br />
          ・クレジットカード決済（<a href='https://www.cardservice.co.jp/service/creditcard/'>株式会社ゼウス</a>）
          <br />
          ・PayPal
          <br />
          ・AmazonPay（法人のみ）
          <br />
          ※順次対応サービスを拡充していく予定です。
        </>
      ),
    },
    {
      title: "カート利用料金はどのように支払えばいいでしょうか？",
      content: <>「銀行振込」・「クレジットカード決済」からお支払い方法を選択頂けます。</>,
    },
  ],
};

const priceFAQ = {
  title: '料金について',
  rows: [
    {
      title: '料金は税込みですか？',
      content: (
        <>
          カートシステム利用料金は、「税込」となります。
          <br />
          クレジットカード決済利用料金は、「税別」となります。こちらの詳細に関しては
          <a href='https://www.cardservice.co.jp/service/creditcard/'>ゼウス社のホームページ</a>をご確認ください。
        </>
      ),
    },
    {
      title: 'カート利用料金はどのように支払えばいいでしょうか？',
      content: <>「銀行振込」・「クレジットカード決済」からお支払い方法を選択頂けます。</>,
    },
    {
      title: "各決済サービスの利用料金はどのように支払えばいいでしょうか？",
      content: (
        <>
          各決済サービス提供会社様とのご契約内容に応じてお支払い下さい（当社に対するお支払いでは無い点ご注意ください）
        </>
      ),
    },
    {
      title: '売上金の入金はどのようにされるのでしょうか？',
      content: (
        <>
          各決済手段によって異なります。なお、当社から入金は行いませんのでご注意ください。
          <br />
          【銀行振込の場合】
          <br />
          ・購入者様がお支払い後に、お客様がご指定の口座に直接ご入金されます。
          <br />
          <br />
          【代引きの場合】
          <br />
          ・配送会社様とのご契約内容に応じて入金されます。
          <br />
          ・入金サイクルなど、ご契約内容の詳細は配送会社様にご確認をお願い致します。
          <br />
          <br />
          【クレジットカード決済・PayPal決済・AmazonPay決済の場合】
          <br />
          ・各決済サービス提供会社様とのご契約内容に応じて入金されます。
          <br />
          ・入金サイクルなど、ご契約内容の詳細は各決済サービス提供会社様にご確認をお願い致します。
          <br />
        </>
      ),
    },
    {
      title: '商品を注文後キャンセル又は返品された場合、システム利用料金は発生しますか？',
      content: (
        <>
          注文された月中にキャンセル、返品、返金が完了した場合であればシステム利用料金は発生しません。
          ただし、注文後、月を跨いでからキャンセル、返品、返金した場合はシステム利用料金が発生いたします。
          <br />
          例）４月中に注文されて４月中キャンセル、返品、返金が完了した場合
          <br />
          　　→システム利用料金は発生しない
          <br />
          　　４月中に注文されて５月以降にキャンセル、返品、返金が完了した場合
          <br />
          　　→システム利用料金が発生
          <br />
        </>
      ),
    },
  ],
};

export const TopFAQ = () => {
  return <FAQPresenter faq={topFAQ} />;
};

export const PriceFAQ = () => {
return < FAQPresenter faq = {priceFAQ} />;
};
